const TypeAheadFilterComponent = {
    templateUrl: '/ui/advancedFilter/component/typeAheadFilter/typeAheadFilter.tpl.html',
    controller: 'typeAheadFilterController',
    bindings: {
        criterionTemplate: '<',
        submissionId: '<',
        advancedFilterType: '<',
        translationsKey: '<?'
    }
};

angular.module('umCore')
    .component('uiTypeAheadFilter', TypeAheadFilterComponent);
